export default {
      id: "instagram-lg-usage",
      viewBox: "0 0 31 28",
      url: __webpack_public_path__ + "svgsprite.svg#instagram-lg",
      toString: function () {
        return this.url;
      }
    }